import React from 'react';
import GenericNomenclatureList from './GenericNomenclatureList';
import { useActionTypeMutations } from '../../../hooks/useNomenclatures';

const ActionTypeList = ({ items, onUpdate }) => {
  const mutations = useActionTypeMutations();

  const fields = [
    { name: 'icon', label: 'Icon', type: 'text', placeholder: 'Icon name or emoji' },
    { name: 'category', label: 'Category', type: 'text', placeholder: 'e.g., Cleaning, Verification' }
  ];

  return (
    <GenericNomenclatureList
      items={items}
      type="action-types"
      title="Action Types"
      fields={fields}
      mutations={mutations}
      onUpdate={onUpdate}
    />
  );
};

export default ActionTypeList;



